import React from "react";
import Google from "../../../Images/Placement/Google.jpeg";
import Talbridge from "../../../Images/Placement/TalBridge.jpeg";
import Medplus from "../../../Images/Placement/Medplus.jpeg";
import Navata from "../../../Images/Placement/Navata.jpeg";
import Aspire from "../../../Images/Placement/Aspire.jpeg";
import Axis from "../../../Images/Placement/Axis.jpeg";
import Genius from "../../../Images/Placement/Genius.jpeg";
import HRGlobe from "../../../Images/Placement/HRGlobe.jpeg";
import HDB from "../../../Images/Placement/HDB.jpeg";
import TaurusBPO from "../../../Images/Placement/TaurusBPO.jpeg";
import Digitide from "../../../Images/Placement/Digitide.jpeg";
import Fruges from "../../../Images/Placement/Fruges.jpeg";
import Muthoot from "../../../Images/Placement/Muthoot.jpeg";
import TechMahindra from "../../../Images/Placement/TechMahindra.jpeg";
import Tech from "../../../Images/Placement/Tech.jpeg";
import NetAmbit from "../../../Images/Placement/NetAmbit.jpeg";
import HRHNext from "../../../Images/Placement/HRHNext.jpeg";
import Thredz from "../../../Images/Placement/Thredz.jpeg";
import Lokal from "../../../Images/Placement/Lokal.jpeg";
import QConneqt from "../../../Images/Placement/QConneqt.jpeg";
import Vizza from "../../../Images/Placement/Vizza.jpeg";
import teamRed from "../../../Images/Placement/TeamRed.jpeg";
import DCS from "../../../Images/Placement/DCS.jpeg";
import Shashwita from "../../../Images/Placement/Shashwita.jpeg";

const placement = [
  {
    image: Axis,
    name: "AXIS",
  },
  {
    image: HDB,
    name: "HDB",
  },
  {
    image: Muthoot,
    name: "Muthoot",
  },
  {
    image: Tech,
    name: "Tech",
  },
  {
    image: Google,
    name: "Google",
  },
  {
    image: TaurusBPO,
    name: "Taurus BPO",
  },
  {
    image: Talbridge,
    name: "Tall Bridge",
  },
  {
    image: Digitide,
    name: "Digi tide",
  },
  {
    image: Fruges,
    name: "Fruges",
  },
  {
    image: Medplus,
    name: "MedPlus",
  },
  {
    image: TechMahindra,
    name: "Tech Mahindra",
  },
  {
    image: HRHNext,
    name: "HRH Next",
  },
  {
    image: Genius,
    name: "Genius",
  },
  {
    image: Thredz,
    name: "Thredz IT",
  },
  {
    image: Lokal,
    name: "Lokal",
  },
  {
    image: QConneqt,
    name: "Conneqt",
  },
  {
    image: Vizza,
    name: "Vizza",
  },
  {
    image: teamRed,
    name: "Team Red",
  },
  {
    image: Navata,
    name: "Navata",
  },
  {
    image: Aspire,
    name: "Aspire",
  },
  {
    image: DCS,
    name: "DCS",
  },
  {
    image: NetAmbit,
    name: "NetAmbit",
  },
  {
    image: HRGlobe,
    name: "HR Global",
  },
  {
    image: Shashwita,
    name: "SHASWITA",
  },
];

const divStyle = {
  color: "#183b56",
};

const PlacementAssociates = () => {
  return (
    <div>
      <h5 className="title-styling text-center fw-medium py-5" style={divStyle}>
        Placement Associates
      </h5>{" "}
      <div className="d-flex flex-wrap gap-3 align-items-center mx-auto justify-content-center">
        {placement.map((obj) => {
          return (
            <div
              key={obj.name}
              className=" hover-shadow placementbody"
              style={{ transition: "all 0.3s ease" }}
            >
              <div className="p-2">
                <div className="">
                  <img
                    src={obj.image}
                    className=" placementImg"
                    alt={obj.name}
                  />{" "}
                </div>
                {/* <h6 className="mb-0 w-fit text-center">{obj.name}</h6> */}
              </div>
              <style
                dangerouslySetInnerHTML={{
                  __html: `
          .hover-shadow:hover {
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
            transform: translateY(-2px);
          }
        `,
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlacementAssociates;
